module.exports = __webpack_public_path__ + "img/arrow_down.9ce27018.svg";